import type React from 'react';
import type { Link } from '@react-navigation/native';

import { getAppNavigationContainerRef } from '../../navigation';

// Logging out requires resetting the stacks from the container reference.
// Otherwise the previous user's screens will still be present in the stacks.
export const resetStacksPostLogout = () => {
  getAppNavigationContainerRef().current?.reset({
    routes: [
      {
        name: 'MainTabs',
        params: {
          screen: 'AccountTab',
          params: { screen: 'AccountMenu' },
        },
      },
    ],
  });
};

// ─── Static Links Config ──────────────────────────────────────────────────────

export const accountMenuStaticLinkConfig: Record<
  string,
  React.ComponentProps<typeof Link>['to']
> = {
  profileLinkConfig: {
    screen: 'MainTabs',
    params: { screen: 'AccountTab', params: { screen: 'Profile' } },
  },
  sweetpassJoinLinkConfig: {
    screen: 'Modal',
    params: { screen: 'SweetpassUpgrade' },
  },
  paymentCreditLinkConfig: {
    screen: 'MainTabs',
    params: { screen: 'AccountTab', params: { screen: 'PaymentCredit' } },
  },
  sweetpassMembershipLinkConfig: {
    screen: 'MainTabs',
    params: { screen: 'AccountTab', params: { screen: 'SweetpassMembership' } },
  },
  addressesLinkConfig: {
    screen: 'MainTabs',
    params: { screen: 'AccountTab', params: { screen: 'Addresses' } },
  },
  ordersLinkConfig: {
    screen: 'MainTabs',
    params: { screen: 'AccountTab', params: { screen: 'Orders' } },
  },
  favoritesLinkConfig: {
    screen: 'MainTabs',
    params: { screen: 'AccountTab', params: { screen: 'Favorites' } },
  },
  referFriendLinkConfig: {
    screen: 'MainTabs',
    params: { screen: 'AccountTab', params: { screen: 'ReferFriend' } },
  },
  dietaryRestrictionsLinkConfig: {
    screen: 'MainTabs',
    params: {
      screen: 'AccountTab',
      params: { screen: 'AccountDietaryRestrictions' },
    },
  },
};
